module.exports = "/_next/static/images/asher-cohen-344708a320c3e488cdfdd9a6272b31c1.jpg";